<template>
  <div class="slider-animation-slow">
    <transition name="slide">
      <jackpots-fall
        v-if="isSlideVisible(1)"
        :currency="data.currency"
        :showSlider="data.fallenJackpots.showSlider"
        :ticketNo="ticketNo"
        :ticketLocation="ticketLocation"
        :jackpotAmount="jackpotAmount"
      />
    </transition>

    <transition name="slide">
          <video-result-slide
            class="slide"
            v-if="isSlideVisible(2)"
            :awayTeam="data.videoResult.AwayTeam"
            :awayTeamShort="data.videoResult.AwayTeamShort"
            :awayTeamLogo="data.videoResult.AwayTeamLogo"
            :homeTeam="data.videoResult.HomeTeam"
            :homeTeamShort="data.videoResult.HomeTeamShort"
            :homeTeamLogo="data.videoResult.HomeTeamLogo"
            :homeScore="data.videoResult.HomeScore"
            :awayScore="data.videoResult.AwayScore"
            :homeHalfTimeScore="data.videoResult.HomeHalfTimeScore"
            :awayHalfTimeScore="data.videoResult.AwayHalfTimeScore"
          />
    </transition>

    <transition name="slide">
      <info-slider class="slide"
        v-if="isSlideVisible(3)"
        :currency="data.currency" />
    </transition>
  </div>
</template>

<script>
import InfoSlider from '@/components/soccer/slides/InfoSlider.vue'
import VideoResultSlide from '@/components/soccer/slides/VideoResultSlide.vue'
import JackpotsFall from '@/components/soccer/slides/JackpotsFall.vue'

export default {
  components: {
    'info-slider': InfoSlider,
    'video-result-slide': VideoResultSlide,
    'jackpots-fall': JackpotsFall
  },
  methods: {
    isSlideVisible (slide) {
      let activeSlide = 1
      if (this.data.showFallenJackpots) {
        activeSlide = 1
      } else if (this.data.showMatchResult && this.data.videoResult) {
        activeSlide = 2
      } else if (this.data.showSlider && !this.data.showMatchResult) {
        activeSlide = 3
      }
      return slide === activeSlide
    }
  },
  computed: {
    ticketNo: function () {
      return this.data.fallenJackpots.ticketNo || ''
    },
    ticketLocation: function () {
      return this.data.fallenJackpots.ticketLocation || ''
    },
    jackpotAmount: function () {
      return this.data.fallenJackpots.jackpotAmount || 0
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>
